import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../lib/theme";

export default function ThemeToggle() {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle"
            className="w-full flex items-center justify-between px-3 py-2 rounded-sm border border-border hover:border-primary text-xs font-medium hover-lift"
        >
            <span className="flex items-center gap-2 text-muted-foreground">
                {isDark ? <Moon size={14} weight="duotone" /> : <Sun size={14} weight="duotone" />}
                <span className="font-mono">{isDark ? "DARK" : "LIGHT"} MODE</span>
            </span>
            <span className="text-foreground/50">↻</span>
        </button>
    );
}
